import { BaseList } from "@design-controls/types";
import React from "react";
import { elementStatus, ElementStatusTag } from "../../domain/elementStatus";
import { QTag } from "@qualio/ui-components";

type Props = Pick<BaseList, "changeControlStatus" | "itemStatus">;

export const DesignElementStatus: React.FC<Props> = (record) => {
  const label = elementStatus(record);

  return <QTag variantColor={ElementStatusTag[label]}>{label}</QTag>;
};

DesignElementStatus.displayName = "QTag";
